import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../shared/services/session.service';
import * as $ from "jquery";
@Component({
  selector: 'app-printpdflist1',
  templateUrl: './printpdflist1.component.html',
  styleUrls: ['./printpdflist1.component.scss']
})
export class Printpdflist1Component implements OnInit {

  public bloburl: string;
  public mydevice: string = "";
public pdf_list_array1=[
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-1.png",
    routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-1.pdf",
    name: "Kap.1",
    opacity: 0.3,
    pointerevents: "none"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-2.png",
    routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-2.pdf",
    name: "Kap.2",
    opacity: 0.3,
    pointerevents: "none"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-3.png",
    routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-3.pdf",
    name: "Kap.3",
    opacity: 0.3,
    pointerevents: "none"
  },
  {
    src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-4.png",
    routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-4.pdf",
    name: "Kap.4",
    opacity: 0.3,
    pointerevents: "none"
  }
];
public pdf_list_array2=[
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-5.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-5.pdf",
    name: "Kap.5",
    opacity: 0.3,
    pointerevents: "none"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-6.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-6.pdf",
   name:"Kap.6"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-7.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-7.pdf",
   name: "Kap.7",
   opacity: 0.3,
   pointerevents: "none"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-8.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-8.pdf",
   name: "Kap.8",
   opacity: 0.3,
   pointerevents: "none"
 }
];
public pdf_list_array3=[
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-9.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-9.pdf",
    name: "Kap.9",
    opacity: 0.3,
    pointerevents: "none"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-10.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-10.pdf",
   name: "Kap.10",
   opacity: 0.3,
   pointerevents: "none"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-11.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-11.pdf",
   name: "Kap.11",
   opacity: 0.3,
   pointerevents: "none"
 },
 {
   src:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Images/Vi-övar-och-lär-12.png",
   routerLink:"/Lasresan/FK/FK-Tilllararen/Kopieringsunderlag/Category1/Pdf/Vi-ovar-och-lar-12.pdf",
   name: "Kap.12",
   opacity: 0.3,
   pointerevents: "none"
 }
];


  constructor(private sessionService: SessionService, ) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
  if(isIOS)
  {
    this.mydevice = "ipad";
  }
  else if (android_dev) {
    this.mydevice = "android";

    if (samsung_browser) {
      this.mydevice = this.mydevice + "_samsung";
    }
    else if (chrome_browser) {
      this.mydevice = this.mydevice + "_chrome";

    }
    var body = document.body;
    body.classList.add(this.mydevice);
  }

  }

  openPDF(url)
  {
    window.open(url, '_blank', 'fullscreen=yes');
    return false;
  }



}
